import React, {useEffect} from "react";
import {useMsal} from "@azure/msal-react";
import {loginRequest} from "./authConfig";
import {globalAdmins, SUPERVISOR_TEAMS} from "./variables/constants";


export const setUserRole = (account) => {
    if (!account) return;
    const email = account.username?.toLowerCase();

    localStorage.removeItem("is_admin");
    localStorage.removeItem("admin_email");
    localStorage.removeItem("admin_name");
    localStorage.removeItem("is_supervisor");
    localStorage.removeItem("supervisor_email");
    localStorage.removeItem("supervisor_name");
    localStorage.removeItem("supervisor_team_members");
    localStorage.removeItem("supervisor_team_members_full");
    localStorage.removeItem("is_team_member");
    localStorage.removeItem("team_member_email");
    localStorage.removeItem("team_member_name");
    localStorage.removeItem("team_member_supervisor");
    localStorage.removeItem("team_member_team_list");

    const isAdmin = globalAdmins.some(
        (adminEmail) => adminEmail.toLowerCase() === email
    );
    if (isAdmin) {
        localStorage.setItem("is_admin", "true");
        localStorage.setItem("admin_email", email);
        localStorage.setItem("admin_name", account.name || email);
        return;
    }

    const supervisorData = SUPERVISOR_TEAMS[email];
    if (supervisorData) {
        localStorage.setItem("is_supervisor", "true");
        localStorage.setItem("supervisor_email", email);
        localStorage.setItem("supervisor_name", supervisorData.supervisorName);
        const teamMemberNames = [...new Set(supervisorData.teamMembers.map((m) => m.name))];
        localStorage.setItem("supervisor_team_members", JSON.stringify(teamMemberNames));
        // Dedupe by name so alias email rows (same person, alternate login) don't double up in UI.
        const seenNames = new Set();
        const uniqueMembers = supervisorData.teamMembers.filter((m) => {
            const key = m.name.toLowerCase();
            if (seenNames.has(key)) return false;
            seenNames.add(key);
            return true;
        });
        localStorage.setItem("supervisor_team_members_full", JSON.stringify(uniqueMembers));
        return;
    }

    let teamMemberData = null;
    for (const [supervisorEmail, teamData] of Object.entries(SUPERVISOR_TEAMS)) {
        const member = teamData.teamMembers.find(
            (m) => m.email.toLowerCase() === email
        );
        if (member) {
            teamMemberData = {
                name: member.name,
                email: member.email,
                supervisorName: teamData.supervisorName,
                supervisorEmail: supervisorEmail
            };
            break;
        }
    }

    if (teamMemberData) {
        localStorage.setItem("is_team_member", "true");
        localStorage.setItem("team_member_email", teamMemberData.email);
        localStorage.setItem("team_member_name", teamMemberData.name);
        localStorage.setItem("team_member_supervisor", teamMemberData.supervisorName);
        const supervisorTeamData = SUPERVISOR_TEAMS[teamMemberData.supervisorEmail];
        if (supervisorTeamData) {
            const teamMemberNames = [...new Set(supervisorTeamData.teamMembers.map((m) => m.name))];
            localStorage.setItem("team_member_team_list", JSON.stringify(teamMemberNames));
        }
    }
};

const LoginPage = () => {
    const { instance } = useMsal();

    useEffect(() => {
        setUserRole(instance.getAllAccounts()[0]);
    }, [instance]);

    const handleLogin = async () => {
        try {
            await instance.loginPopup(loginRequest);
            setUserRole(instance.getAllAccounts()[0]);
        } catch (err) {
            console.error("Login failed", err);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 text-center">
                <h1 className="text-3xl font-semibold text-gray-800 mb-4">
                    Sign in to Gabriel & Co Dashboard
                </h1>
                <p className="text-gray-600 mb-6">
                    Please sign in with your Microsoft account to continue.
                </p>
                <button
                    onClick={handleLogin}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 rounded-md shadow transition duration-200"
                >
                    Sign in with Microsoft
                </button>
            </div>
        </div>
    );
};

export default LoginPage;
